import React, { useEffect, useRef } from 'react';
import { paintDotGrid } from '../../signup-review/dotGridPainter';

// Same painter as signup, scoped to the hero rather than the entire viewport.
export const HeroDotBackground = () => {
  const ref = useRef(null);
  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext('2d');
    if (!ctx) { canvas.dataset.renderMode = 'fallback'; return undefined; }
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    let width = 0, height = 0, frame = 0, visible = true;
    let current = { x: 0, y: 0, power: 0 }, target = { ...current };
    const stop = () => { cancelAnimationFrame(frame); frame = 0; };
    const draw = () => paintDotGrid(ctx, width, height, current);
    const animate = () => {
      frame = 0;
      if (!visible || document.hidden) return;
      const delta = Math.abs(current.x - target.x) + Math.abs(current.y - target.y) + Math.abs(current.power - target.power) * 100;
      current.x += (target.x - current.x) * .16; current.y += (target.y - current.y) * .16; current.power += (target.power - current.power) * .12;
      if (delta < .12) current = { ...target };
      draw();
      if (delta >= .12) frame = requestAnimationFrame(animate);
    };
    const schedule = () => { if (!frame && visible && !document.hidden) frame = requestAnimationFrame(animate); };
    const resize = () => {
      stop();
      const rect = canvas.getBoundingClientRect(); width = rect.width; height = rect.height;
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(width * dpr); canvas.height = Math.round(height * dpr); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      current = { x: width * .68, y: height * .45, power: 0 }; target = { ...current };
      canvas.dataset.renderMode = reduced.matches ? 'reduced-motion' : fine.matches ? 'interactive' : 'static';
      draw(); canvas.dataset.ready = 'true';
    };
    const move = event => {
      if (!visible || document.hidden || reduced.matches || !fine.matches || event.pointerType === 'touch') return;
      const rect = canvas.getBoundingClientRect();
      const x = event.clientX - rect.left, y = event.clientY - rect.top;
      target = x >= 0 && y >= 0 && x <= width && y <= height ? { x, y, power: 1 } : { ...target, power: 0 };
      schedule();
    };
    const leave = () => { target.power = 0; if (!reduced.matches) schedule(); };
    const visibility = () => { if (document.hidden) stop(); else resize(); };
    const observer = new ResizeObserver(resize);
    const intersection = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; if (!visible) stop(); });
    observer.observe(canvas); intersection.observe(canvas); resize();
    window.addEventListener('pointermove', move, { passive: true }); window.addEventListener('blur', leave);
    document.documentElement.addEventListener('pointerleave', leave); document.addEventListener('visibilitychange', visibility);
    reduced.addEventListener('change', resize); fine.addEventListener('change', resize);
    return () => { stop(); observer.disconnect(); intersection.disconnect(); window.removeEventListener('pointermove', move); window.removeEventListener('blur', leave); document.documentElement.removeEventListener('pointerleave', leave); document.removeEventListener('visibilitychange', visibility); reduced.removeEventListener('change', resize); fine.removeEventListener('change', resize); };
  }, []);
  return <div className="hm-restored-backdrop" aria-hidden="true" data-testid="home-hero-background"><canvas ref={ref} data-testid="home-hero-dot-canvas" /></div>;
};